import { render, staticRenderFns } from "./FbRichText.vue?vue&type=template&id=20d1f28d"
import script from "./FbRichText.vue?vue&type=script&lang=js"
export * from "./FbRichText.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports